<template>
  <div>
    <el-upload
      :accept="accept"
      class="image-upload"
      :class="{
        'image-upload--empty': isEmpty,
        'image-upload--loading': loading,
      }"
      :file-list="fileList"
      :http-request="uploadFromRequest"
      :on-error="onError"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-success="onSuccess"
      action
      list-type="picture-card"
      ref="files"
    >
      <i class="el-upload__icon icon-camera" />
      <span
        class="el-upload__text"
        v-text="placeholder"
      />
      <div class="el-upload__icon">
        <i :class="iconClass" />
        <span
          class="el-upload__sub-text"
          v-text="i18n('fileUploader.uploadFile')"
        />
      </div>
      <div
        v-if="tooltipContentI18nCode && tooltipIconClass"
        class="el-upload__tooltip"
      >
        <el-tooltip
          :content="i18n(tooltipContentI18nCode)"
          placement="right"
          popper-class="image-upload__tooltip"
        >
          <i :class="tooltipIconClass" />
        </el-tooltip>
      </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible">
      <img
        :src="dialogImageUrl"
        alt
        width="100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { FileUploader } from '@shared/firebase/file-uploader';

export default {
  name: 'app-image-upload',

  props: {
    path: String,
    value: Array,
    schema: Object,
    max: Number,
    placeholder: String,
    accept: {
      type: String,
      default: 'image/*'
    },
    tooltipContentI18nCode: String,
    tooltipIconClass: String,
  },

  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: (this.value || []).map((item) => ({
        ...item,
        url: item.publicUrl,
      })),
      loading: false,
      i18n,
    };
  },

  computed: {
    iconClass() {
      return 'icon-camera'
    },
    isEmpty() {
      return !this.value || !this.value.length;
    },
    isFull() {
      const hasInputReference = !!this.$refs.files;

      return (
        (this.max &&
          (hasInputReference &&
            this.$refs.files.uploadFiles.length >=
              this.max)) ||
        (!hasInputReference &&
          (this.value || []).length >= this.max)
      );
    },
  },

  methods: {
    async uploadFromRequest(request) {
      this.loading = true;
      request.onProgress({ percent: 0 });

      return FileUploader.uploadFromRequest(
        this.path,
        request,
        this.schema,
      );
    },

    onSuccess(file) {
      if (!file) return;
      this.$emit('input', [...(this.value || []), file]);
      this.$emit('success');
      this.loading = false;
    },

    onError() {
      this.loading = false;
    },

    onRemove(file) {
      if (!file) return;

      const id = file.response ? file.response.id : file.id;

      this.$emit(
        'input',
        (this.value || []).filter(
          (item) => item.id !== id,
        ),
      );
    },

    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.image-upload {
  position: relative;
  margin: 0 auto;
  display: inline-block;

  &__tooltip {
    max-width: 280px;
  }

  .el-upload-list {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;

    .el-upload-list__item {
      .el-upload-list__item-thumbnail {
        object-fit: cover;
      }
    }
  }

  .el-progress-circle__path {
    stroke: #2acccc;
  }

  .el-upload__tooltip {
    i {
      position: absolute;
      top: 0;
      right: 10px;

      &::before {
        color: #404040;
        font-size: 20px;
      }
    }
  }

  &--loading {
    .el-upload--picture-card {
      pointer-events: none;
    }
  }

  &--empty {
    .el-upload-list--picture-card {
      pointer-events: none;
    }
  }

  &--hide-upload {
    .el-upload--picture-card {
      opacity: 0;
    }
  }

  .el-upload__sub-text {
    display: none;
  }

  .el-upload--picture-card {
    grid-template-rows: 20% 40% 40%;
    padding: 0 16px;

    .el-upload__icon {
      justify-self: center;
      text-align: center;
      align-self: center;

      i {
        color: #cccccc;
        font-size: 48px;
      }
    }
  }
}

</style>
